import React from 'react';
import Modal from 'react-modal';
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            :  'none',
    overflow              : 'hidden'
  }
};

class RecordedVideos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            deleteDisabled: false,
            bigImage: ""
          };

          this.openModal = this.openModal.bind(this);
          this.afterOpenModal = this.afterOpenModal.bind(this);
          this.closeModal = this.closeModal.bind(this);
      }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    openModal() {
        this.setState({modalIsOpen: true});
      }
     
      afterOpenModal() {

      }
     
      closeModal() {
        this.setState({modalIsOpen: false});
      }

    render() {
      const { t } = this.props;
        var videos = this.props.recordedvideos.map((value, i) =>{
            let key = "vid_"+i;
            var splitString = value.recording.split('/');
            const videoNameSplit = splitString[splitString.length - 1];
            const videoName = videoNameSplit.split("?")[0];
            return (
              <div className="VideoAndName">
                <video className="CaptureVideoDisplay"
                key={key}
                src={value.recording}
                onClick={(event) =>{
                    this.onClick(value.recording);
                }}
                alt ="Recorded Videos"
                preload="metadata"
               // poster="./images/video_poster.png"
               poster={value.thumbnail}
                />
                <div  className="VideoName">{videoName}</div>
                </div>
            );
          });


        return (
          <div   className="RecordedVideoContainer">
          <div  className="ContentTitle"> {t("videos")} </div>
            <div className="ContentOverFlow">{videos}</div>
            <Modal
              isOpen={this.state.modalIsOpen}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModal}
              style={customStyles}
              contentLabel="Dialog Video"
              appElement={document.getElementById("root")}
            >
              <div className="BigImageDisplayContainer">
                <video
                  className="BigImageDisplay"
                  key="bigimage"
                  src={this.state.bigImage}
                  alt=""
                  controls
                />
              </div>
              <div className="ModalDialogFooter">

                <div className="ModalButtonWrapper">
                  <button
                    className="ModalButtonStyle"
                    onClick={()=>{this.deleteVideo()}}
                    disabled={this.state.deleteDisabled}
                    id="end_id"
                  >
                    {t("delete")} 
                  </button>

                  <button
                    className="ModalButtonStyle"
                    onClick={this.closeModal}
                    id="end_id"
                  >
                    {t("close")} 
                  </button>
                </div>

              </div>
            </Modal>
          </div>
        );
    }

    deleteVideo(){
      this.setState({deleteDisabled : true});
      this.props.deleteVideo(this.state.bigImage, ()=>{
        this.setState({deleteDisabled : false});
        this.closeModal();
      });
    }

    onClick(value){
        console.log(JSON.stringify(value));
        this.setState({bigImage: value});
        this.openModal();
    }


}

export default RecordedVideos;